var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDomotzVendorConnect = function SvgDomotzVendorConnect(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#152A49;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 500,
    cy: 500,
    r: 494
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M731.8,534.3V207.2c0-22.2-18.2-40.4-40.4-40.4c-22.2,0-40.4,18.2-40.4,40.4v329.1c0,22.2,2,82.8-2,111.1 c-8.1,58.6-72.7,107-147.4,107c-84.8-2-153.5-70.7-153.5-157.5c0-86.8,70.7-155.5,155.5-155.5c10.1,0,20.2,2,32.3,6.1l4,2 c22.2,6.1,42.4-8.1,48.5-28.3c6.1-22.2-8.1-42.4-28.3-48.5l-6.1-4c-14.1-4-32.3-8.1-50.5-8.1c-131.3,0-236.3,107-236.3,236.3 s105,236.3,236.3,236.3c115.1,0,216.1-78.8,228.2-177.7C733.8,617.1,731.8,542.4,731.8,534.3z M550,382.9 c16.2,0,28.3,12.1,28.3,28.3c0,16.2-12.1,28.3-28.3,28.3s-28.3-12.1-28.3-28.3C521.8,395,533.9,382.9,550,382.9z M691.4,235.5 c-16.2,0-28.3-12.1-28.3-28.3s12.1-28.3,28.3-28.3s28.3,12.1,28.3,28.3S707.5,235.5,691.4,235.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDomotzVendorConnect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "domotz_vendor_connect.008c733bf49016a4f5be7606ee107f7c.svg";